import controller from './navbar.controller';
import template from './navbar.html';

const navbarComponent = {
  restrict: 'E',
  bindings: {},
  controller,
  template
};

export default navbarComponent;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/navbar/navbar.component.js
 **/